import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import {fetchAdminSingleType, saveAdminSingleType} from "../../system/content-type-admin-api";

export default class BillingSetting extends BaseStrapiCollection {
    static kind = "singleType";
    static singularName = "billing-setting";
    static pluralName = "billing-settings";
    static displayName = "BillingSetting";

    constructor() {
        super(`${BillingSetting.kind}`, `${BillingSetting.singularName}`, `${BillingSetting.pluralName}`);
    }

    async getAll() {
        return {data: await fetchAdminSingleType("api::billing-setting.billing-setting")};
    }

    async save(data) {
        return {data: await saveAdminSingleType("api::billing-setting.billing-setting", data)};
    }
}
